var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Contract } from 'ethers';
import { Lifecycle, inject, scoped } from 'tsyringe';
import { ConfigInjectionToken } from '../ConfigTypes';
import { StreamrClientEventEmitter } from '../events';
import { LoggerFactory } from '../utils/LoggerFactory';
import { createDecoratedContract } from './contract';
let ContractFactory = class ContractFactory {
    config;
    eventEmitter;
    loggerFactory;
    /* eslint-disable indent */
    constructor(config, eventEmitter, loggerFactory) {
        this.config = config;
        this.eventEmitter = eventEmitter;
        this.loggerFactory = loggerFactory;
    }
    createReadContract(address, contractInterface, provider, name) {
        return createDecoratedContract(new Contract(address, contractInterface, provider), name, this.loggerFactory, this.config.contracts.maxConcurrentCalls);
    }
    createWriteContract(address, contractInterface, signer, name) {
        const contract = createDecoratedContract(new Contract(address, contractInterface, signer), name, this.loggerFactory, 
        // The current maxConcurrentCalls value is just a placeholder as we don't support concurrent writes (as we don't use nonces).
        // When we add the support, we should use the maxConcurrentCalls option from client config here.
        // Also note that if we'd use a limit of 1, it wouldn't make the concurrent transactions to a sequence of transactions,
        // because the concurrency limit covers only submits, not tx.wait() calls.
        999999);
        contract.eventEmitter.on('onTransactionConfirm', (methodName, receipt) => {
            this.eventEmitter.emit('contractTransactionConfirmed', {
                methodName,
                receipt
            });
        });
        return contract;
    }
    // eslint-disable-next-line class-methods-use-this
    createEventContract(address, contractInterface, provider) {
        return new Contract(address, contractInterface, provider);
    }
};
ContractFactory = __decorate([
    scoped(Lifecycle.ContainerScoped),
    __param(0, inject(ConfigInjectionToken)),
    __metadata("design:paramtypes", [Object, StreamrClientEventEmitter,
        LoggerFactory])
], ContractFactory);
export { ContractFactory };
//# sourceMappingURL=ContractFactory.js.map